export default {
  getProducts: state => state.items
}



// WEBPACK FOOTER //
// ./src/store/modules/products/getters.js